import {defineStore} from "pinia"
import {ref,computed}         from "vue"
import axios         from "axios"

export const useAuthStore = defineStore("auth", () => {
  const isLoggedIn     = ref(false)
  const user = ref()
  const getCurrentUser = async () => {
  
    try {
      const {data}   = await axios({
        url   : '/api/user',
        method: 'get',
        // data:formData.value,
        withCredentials: true,
      })
      isLoggedIn.value = true
      user.value = data
    } catch (e) {
      isLoggedIn.value = false
    }

    return isLoggedIn.value
  }
  const isSuper= computed(
    () => {
      return user.value && user.value.super
    }
  ) 
  return {isLoggedIn, getCurrentUser, isSuper}
})

